import cx from 'clsx';

import { ChipProps } from './Chip';
import chipClasses from './Chip.module.css';

export const ChipOverrideClassNames = (props: ChipProps) => {
  return {
    label: cx(chipClasses.label, {
      [chipClasses.labelXs]: props.size === 'xs',
      [chipClasses.labelSm]: props.size === 'sm',
      [chipClasses.labelMd]: props.size === 'md',
      [chipClasses.labelLg]: props.size === 'lg',
      [chipClasses.labelXl]: props.size === 'xl'
    }),
    iconWrapper: !props.tick ? chipClasses.noIconWrapper : ''
  };
};
